import type { ToolGroup } from '../types';
import { getWorkflowToolDefinitions, handleWorkflowTool } from './workflows';
import {
  getWorkflowProposalsToolDefinitions,
  handleWorkflowProposalsTool,
} from './workflow-proposals';
import { getWorkflowRunsToolDefinitions, handleWorkflowRunsTool } from './workflow-runs';
import { getTestSuiteToolDefinitions, handleTestSuiteTool } from './test-suites';
import { getCredentialToolDefinitions, handleCredentialTool } from './credentials';
import { getIssueToolDefinitions, handleIssueTool } from './issues';

export const workflowsGroup: ToolGroup = {
  id: 'workflows',
  definitions: getWorkflowToolDefinitions,
  handle: (tool, args) => handleWorkflowTool(tool, args),
};

export const workflowProposalsGroup: ToolGroup = {
  id: 'workflow-proposals',
  definitions: getWorkflowProposalsToolDefinitions,
  handle: (tool, args) => handleWorkflowProposalsTool(tool, args),
};

export const workflowRunsGroup: ToolGroup = {
  id: 'workflow-runs',
  definitions: getWorkflowRunsToolDefinitions,
  handle: (tool, args) => handleWorkflowRunsTool(tool, args),
};

export const testSuitesGroup: ToolGroup = {
  id: 'test-suites',
  definitions: getTestSuiteToolDefinitions,
  handle: (tool, args) => handleTestSuiteTool(tool, args),
};

export const credentialsGroup: ToolGroup = {
  id: 'credentials',
  definitions: getCredentialToolDefinitions,
  handle: (tool, args) => handleCredentialTool(tool, args),
};

export const issuesGroup: ToolGroup = {
  id: 'issues',
  definitions: getIssueToolDefinitions,
  handle: (tool, args) => handleIssueTool(tool, args),
};

/**
 * All HTTP-only groups (no daemon, no CLI auth state). Safe to use from any
 * MCP host that has an `apiToken` for the canary API.
 */
export const sharedGroups: ToolGroup[] = [
  workflowsGroup,
  workflowProposalsGroup,
  workflowRunsGroup,
  testSuitesGroup,
  credentialsGroup,
  issuesGroup,
];
